module.exports = __webpack_public_path__ + "img/preview-changes.9bfd6a03.jpg";